module.exports = __webpack_public_path__ + "static/media/ventil_bild_richtig.740c83a9.jpg";